import React from "react"

import "./resources.scss"

const Resources = props => {
  return (
    <div className="resources">
      <div className="container">
        <h3 className="resources__headline">{props.headline}</h3>
        <div className="resources__container">
          {props.resource.map((resource, index) => (
            <div className="resource" key={index}>
              <img src={resource.badge.url} />
              <div
                className="resource__text"
                dangerouslySetInnerHTML={{ __html: resource.body_copy }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Resources
